module.exports = __webpack_public_path__ + "static/media/diversao.ee216df7.svg";